module.exports = __webpack_public_path__ + "media/images/partners/obn-2e41e7a9ac9f34dfcb2e4500db18133e.png";